import { render, staticRenderFns } from "./ServerSettings.vue?vue&type=template&id=54a85d7e&scoped=true&"
import script from "./ServerSettings.vue?vue&type=script&lang=js&"
export * from "./ServerSettings.vue?vue&type=script&lang=js&"
import style0 from "./ServerSettings.vue?vue&type=style&index=0&id=54a85d7e&prod&lang=scss&"
import style1 from "./ServerSettings.vue?vue&type=style&index=1&id=54a85d7e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a85d7e",
  null
  
)

export default component.exports